const actions = [
    {
        routeName: 'availability_pricing.index',
        items: [
            {
                title: 'add available unit',
                routeName: 'availability_pricing.create',
            },
            {
                title: 'import availability list',
                routeName: 'availability_pricing.template',
            },
        ],
    },
];

export default actions;
